import React from 'react'
import { useSelector } from 'react-redux'
import { isLandmark, isNamedPlace, isWay } from '../../store/address/address.helpers'
import { selectFirstAddress } from '../../store/address/address.selectors'
import { selectLocale } from '../../store/navigation/navigation.selectors'
import { selectSearchTerms } from '../../store/search/search.selectors'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import { withTranslation } from '../i18n/T'
import s from '../map/StaticMap.less'
import { isWayDashZipDashCity, isZipDashCity } from '../utils/location'
import { getImagePath } from './seo/AddressImage.utils'
import { localeLanguageIsFrench } from '../i18n/i18n.utils'
import { landmarkSubtypeLabels } from '../../store/search/search.service.constants'

const getSubType = (address, locale) => {
  if (!localeLanguageIsFrench(locale)) return ''
  const label = landmarkSubtypeLabels[address.subtype]
  return label ? ` - ${label}` : ''
}

const getLabel = (t, address) => {
  if (!address) return
  const { label } = address

  if (isNamedPlace(address) || isLandmark(address) || isWay(address)) {
    return t('address.nojs_map.static_map_img_alt.basic', [label])
  }

  return t('address.nojs_map.static_map_img_alt', [label, label])
}

export const AddressMapImage = ({ t }) => {
  const locale = useSelector(selectLocale)
  const address = useSelector(selectFirstAddress)
  const searchTerms = useSelector(selectSearchTerms)

  if (locale.startsWith('en')) return <></>
  const areValidSearchTerms = isWay(address) ? isWayDashZipDashCity(searchTerms) : isZipDashCity(searchTerms)
  if (!areValidSearchTerms) return <></>

  const src = getImagePath(address)
  if (!src) return <></>

  return (
    <img
      id="AddressMapImage"
      src={src}
      alt={`${getLabel(t, address)}${getSubType(address, locale)}`}
      className={s.StaticMap}
    />
  )
}

export default withEmptyFallbackErrorBoundary(withTranslation(AddressMapImage))
